"use strict";

export default function () {
    if (matchMedia('(max-width: 767px)').matches) {
        var mainNavLinkToggler = $('.js-touch-nav>li> .nav-link__toggle');

        mainNavLinkToggler.on('click', function (evt) {
            var parent = $(this).parent();
            if (parent.hasClass('active')) {
                parent.removeClass('active');
            } else {
                parent.addClass('active');
            }
        });
    }
}